import { IOrderIntV2, IOrdersIntV2Filters } from '@telstra-connect/order-tracker/state/orders';

export function filterOrdersIntV2(originalOrders: IOrderIntV2[], filters: IOrdersIntV2Filters, searchString?: string): IOrderIntV2[] {
  let filterdActiveOrders = originalOrders;

  if (filters?.location?.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) =>  filters.location.findIndex((fl) => l.location.split('---')[1] && fl.value === l.location.split('---')[0]) !== -1);
  }

  if (filters?.siteAddress?.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => filters.siteAddress.findIndex((fl) => l.location.split('---')[1] && fl.value === l.location.split('---')[1]) !== -1);
  }

  if (filters?.productName?.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => filters.productName.findIndex((fl) => fl.value === l.name) !== -1);
  }

  if (filters?.status?.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.status.filter((s) => l.orderStatus === s.value)
      ).length);
  }

  if (searchString && searchString.trim().length > 0) {
    filterdActiveOrders = searchOrdersIntV2(filterdActiveOrders, searchString)
  }
  return filterdActiveOrders;
}

export function searchOrdersIntV2(originalOrders: IOrderIntV2[], searchStringParam: string): IOrderIntV2[] {
  const searchActiveOrders = originalOrders;
  const searchString = searchStringParam.toLowerCase();

  const searchActiveNumberOrders = searchActiveOrders.filter((e) => e.orderNumber &&
    e.orderNumber.toLowerCase().includes(searchString))
  const searchActiveNcpOrders = searchActiveOrders.filter((e) => e.ncp && e.ncp.toLowerCase().includes(searchString));
  const searchActiveNameOrders = searchActiveOrders.filter((e) => e.name &&
    e.name.toLowerCase().includes(searchString))
  const searchActiveFilterLocationOrders = searchActiveOrders.filter((e) => e.filterLocation.filter((v) =>
    (v.value.toLowerCase().includes(searchString))).length);
  const searchActiveStatusOrders = searchActiveOrders.filter((e) => e.orderStatus &&
    e.orderStatus.toLowerCase().includes(searchString));
  const searchActiveSitesCompleteOrders = searchActiveOrders.filter((e) => e.sitesComplete &&
    e.sitesComplete.toLowerCase().includes(searchString));
  const searchActiveEstimatedOrders = searchActiveOrders.filter((e) =>
    e.estimatedDelivery && e.estimatedDelivery.toLowerCase().includes(searchString));
  const searchActiveFullfilledOrders = searchActiveOrders.filter((e) =>
    e.closedDate && e.closedDate.toLowerCase().includes(searchString));
  const searchActiveRequiredOrders = searchActiveOrders.filter((e) =>
    e.requiredDelivery && e.requiredDelivery.toLowerCase().includes(searchString));
  const searchActiveCustomerName = searchActiveOrders.filter((e) =>
    e.customerName && e.customerName.toLowerCase().includes(searchString));
  const searchActiveCustomerId = searchActiveOrders.filter((e) =>
    e.cidn && e.cidn.toLowerCase().includes(searchString));
  const searchYourReference = searchActiveOrders.filter((e) =>
    e.yourReference && e.yourReference.toLowerCase().includes(searchString));
  const searchProjectManager = searchActiveOrders.filter((e) =>
    e.projectManager && e.projectManager.toLowerCase().includes(searchString));

  const ordersArray = [...searchActiveNumberOrders, ...searchActiveNcpOrders, ...searchYourReference,
    ...searchActiveNameOrders, ...searchActiveFilterLocationOrders, ...searchActiveStatusOrders,
    ...searchActiveSitesCompleteOrders, ...searchActiveEstimatedOrders, ...searchActiveFullfilledOrders,
    ...searchProjectManager, ...searchActiveCustomerName, ...searchActiveCustomerId, ...searchActiveRequiredOrders];

  return ordersArray;
}
